import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
  },
});

export interface StockItem {
  _id?: string;
  name: string;
  unit: string;
  description?: string;
  price?: number | null;
  isActive?: boolean;
}

export interface KitchenStockInfo {
  stockItemId: string;
  name: string;
  unit: string;
  description?: string;
  quantity: number;
  updatedAt?: string;
}

const stocksApi = {
  // Global Stock Item Templates
  getStocks: async (): Promise<{ success: boolean; data: StockItem[] }> => {
    const response = await axios.get(`${API_URL}/api/admin/stocks`, getAuthHeaders());
    return response.data;
  },

  createStockItem: async (payload: Partial<StockItem>): Promise<{ success: boolean; data: StockItem }> => {
    const response = await axios.post(`${API_URL}/api/admin/stocks`, payload, getAuthHeaders());
    return response.data;
  },

  updateStockItem: async (id: string, payload: Partial<StockItem>): Promise<{ success: boolean; data: StockItem }> => {
    const response = await axios.put(`${API_URL}/api/admin/stocks/${id}`, payload, getAuthHeaders());
    return response.data;
  },

  deleteStockItem: async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await axios.delete(`${API_URL}/api/admin/stocks/${id}`, getAuthHeaders());
    return response.data;
  },

  // Kitchen Stock Levels
  getKitchenStocks: async (kitchenId: string): Promise<{ success: boolean; data: KitchenStockInfo[] }> => {
    const response = await axios.get(`${API_URL}/api/admin/stocks/kitchen/${kitchenId}`, getAuthHeaders());
    return response.data;
  },

  updateKitchenStock: async (
    kitchenId: string,
    payload: { stockItemId: string; quantity: number; operation: "add" | "set" }
  ): Promise<{ success: boolean; message: string; data: any }> => {
    const response = await axios.post(`${API_URL}/api/admin/stocks/kitchen/${kitchenId}`, payload, getAuthHeaders());
    return response.data;
  },
};

export default stocksApi;
